export default __webpack_public_path__ + "static/media/cadeia.7b873a97.png";